import React, { FC, useEffect } from 'react'
import { Outlet, RouteProps } from 'react-router-dom'

// utils
import { PAGE } from '../utils/enums'

type Props = RouteProps & {
	layout?: any
	element?: React.Component<any>
	page?: PAGE
}

const BaseRoute: FC<Props> = (props) => {
	const { layout: Layout } = props

	useEffect(() => {
		document.title = 'Paradigma'
	}, [])

	if (Layout) {
		return (
			<Layout {...props}>
				<Outlet />
			</Layout>
		)
	}
	return <Outlet />
}

export default BaseRoute
